import {API} from "@/Composables/api";

const getFeed = async (params) => {
    return API.get(route("feed.index"), params);
};

const getQuestions = async (params) => {
    return API.get(route("questions.index"), params);
};

const getLaunchQuestions = async (params) => {
    return API.get(route("questions.launch"), params);
};

const getQuestion = async (question, params?) => {
    return API.get(route("questions.show", {question}), params);
};

const getQuestionPreview = async (question, params = {}) => {
    console.log("api question preview data", question);
    return API.post(route("question-previews.store"), params, question);
};

const storeQuestion = async (question, params = {}) => {
    return API.post(route("questions.store"), params, question);
};

const updateQuestion = async (question, params = {}) => {
    return API.put(route("questions.update", {question}), params, question);
};

const duplicateQuestion = async (question: string, params = {}) => {
    return API.post(route("questions.duplicate", {question}), params, {});
};

const duplicateMultipleQuestions = async (questionIds: string[], params = {}) => {
    return API.post(route("questions.duplicate-multiple"), params, {question_ids: questionIds});
};

const shareQuestion = async (question: string, formData, params = {}) => {
    return API.post(route("questions.share", {question}), params, formData);
};

const shareMultipleQuestions = async (questionIds: string[], userId: string, params = {}) => {
    return API.post(route("questions.share-multiple"), params, {question_ids: questionIds, user_id: userId});
};

const copyQuestion = async (question: string, formData, params = {}) => {
    return API.post(route("questions.questions.copy", question), params, formData);
};

const deleteQuestion = async (question: string, params = {}) => {
    return API.delete(route("questions.destroy", question), params);
};

const deleteMultipleQuestions = async (questionIds: string[], params = {}) => {
    return API.post(route("questions.destroy-multiple"), params, {question_ids: questionIds});
};

const restoreQuestion = async (question: string, params = {}) => {
    return API.post(route("questions.restore", question), params);
};

const restoreMultipleQuestions = async (questionIds: string[], params = {}) => {
    return API.post(route("questions.restore-multiple"), params, {question_ids: questionIds});
};

export {
    getQuestions,
    getQuestion,
    getQuestionPreview,
    storeQuestion,
    copyQuestion,
    shareQuestion,
    shareMultipleQuestions,
    deleteQuestion,
    deleteMultipleQuestions,
    duplicateQuestion,
    duplicateMultipleQuestions,
    getFeed,
    getLaunchQuestions,
    updateQuestion,
    restoreQuestion,
    restoreMultipleQuestions,
};
